import { getAnalytics } from "@tm/insurance/analytics";
import { H4Tag, H5Tag, ParaTag } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import {
  IntersectionObserverData,
  useIntersectionObserver,
} from "@tm/ui/hooks";
import { useCallback, useRef } from "react";
import {
  InsuranceStatsStyle,
  InsuranceStatsWrap,
} from "./InsuranceStats.style";

interface InsuranceStatsProps {
  data?: {
    title: string;
    info: string;
  }[];
}

const InsuranceStats = ({ data }: InsuranceStatsProps) => {
  const device = useBreakpointV2();
  const analytics = getAnalytics();
  const hasTracked = useRef<boolean>(false);

  // Track component view when it comes into viewport
  const handleIntersection = useCallback((data: IntersectionObserverData) => {
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "insurance_stats_seen",
      });
    }
    hasTracked.current = true;
  }, []);

  const { ref: statsRef } = useIntersectionObserver(handleIntersection, {
    threshold: 0.5, // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true,
  });

  return (
    <InsuranceStatsWrap ref={statsRef} id="insurance-stats">
      <InsuranceStatsStyle>
        {data &&
          data.map((item, index) => {
            return (
              <div key={index}>
                {device == "lg" ? (
                  <H4Tag margin="0 0 4px">{item.title}</H4Tag>
                ) : (
                  <H5Tag margin="0 0 4px">{item.title}</H5Tag>
                )}
                <ParaTag fontSize={device == "lg" ? "md" : "xs"}>
                  {item.info}
                </ParaTag>
              </div>
            );
          })}
      </InsuranceStatsStyle>
    </InsuranceStatsWrap>
  );
};

export default InsuranceStats;
